import { axiosICPLBEInstance } from "../../../utils/axios_config";

export default function BatchingPlantService() {
    this.getBatchingPlants = (payload) => {
        return axiosICPLBEInstance.get(`batchingplant?page=${payload.page}&page_length=${payload.page_length}`);
    }
}